import type { Address, CaseExtras, CaseType, DataEnabledTag, DynamicValue, Gender } from "@/App/types/twiageTypes";
import type { GpsLocation } from "@/App/types/GpsLocation";
import { AgePeriod } from "@/Pages/Cases/types/age/agePeriod";
import type { Nullable } from "@/App/types/Nullable";
import type { Ift } from "@/App/types/Ift";
import type { PatientContact } from "@/App/types/Mih";

export type CaseRequestBody = {
  age?: Nullable<number>;
  agePeriod?: Nullable<AgePeriod>;
  sex?: string;
  complaint?: string;
  complaintSet?: string;
  dataEnabledTags: DataEnabledTag[];
  destinationHospital?: string;
  emsAgency?: string;
  dynamicValues: DynamicValue[];
  estimatedArrival?: number;
  gender?: Gender;
  tags: string[];
  type: CaseType;
  walkIn?: boolean;
  ift?: Ift;
  mih?: MihRequestBody;
  extras?: CaseExtras;
};

export type MihRequestBody = {
  location?: { address?: Address; coordinates?: GpsLocation };
  appointmentTime?: string;
  addressIsPatientAddress?: boolean;
  contact?: PatientContact;
};

export const caseRequestBodyFields: (keyof CaseRequestBody)[] = [
  "age",
  "agePeriod",
  "sex",
  "gender",
  "destinationHospital",
  "emsAgency",
  "complaint",
  "complaintSet",
  "dynamicValues",
  "estimatedArrival",
  "walkIn",
  "ift",
  "mih",
  "extras",
  "tags",
];
